// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dropdown__eiAH14lrvH{z-index:10000}`, "",{"version":3,"sources":["webpack://./src/assets/components/conversation/components/header/actionBar/components/conversationFollowUp/conversationFollowUp.module.scss"],"names":[],"mappings":"AAAA,sBACE,aAAA","sourcesContent":[".dropdown {\n  z-index: 10000;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dropdown": `dropdown__eiAH14lrvH`
};
export default ___CSS_LOADER_EXPORT___;
